module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_05-3e53768aff46a6b1f5ac1b4bc179993d.webp";